import { API } from "@/services"

export const REQUEST_LOGS_ENDPOINTS = {
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `request-logs`,
      method: 'GET',
      params,
    })
  },
  getById(id='',params={}){
    return API.Axios.universal_ai.v1.request({
      url: `request-logs/${id}`,
      method: 'GET',
      params,
    })
  },
  chart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `request-logs/chart`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `request-logs/${id}`,
      method: 'DELETE',
      data,
    })
  },
}